import React from 'react'

// Inline, field-level validation error - sits directly under the input it belongs to.
// Gives the message a contained surface (not just floating red text) so it reads clearly
// as an error rather than as another line of body copy.
function FieldError({ children }) {
  if (!children) return null
  return (
    <div className="flex items-start gap-1.5 mt-2 px-2.5 py-2 bg-red-50 border border-red-200 rounded-sm">
      <svg width="13" height="13" viewBox="0 0 20 20" fill="none" className="flex-none mt-[2px]">
        <circle cx="10" cy="10" r="8.25" stroke="#b91c1c" strokeWidth="1.4" />
        <path d="M10 6.2v4.6" stroke="#b91c1c" strokeWidth="1.6" strokeLinecap="round" />
        <circle cx="10" cy="13.7" r="0.9" fill="#b91c1c" />
      </svg>
      <p className="m-0 font-plexsans text-[12px] leading-[1.5] text-red-700">{children}</p>
    </div>
  )
}

export default FieldError
